import { useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { IErrorResponse } from "@api";
import {
  IBasket,
  IOrderPreviewBody,
  previewBasketOrder,
} from "../services/baskets";

export const useOrderPreview = ({
  basketId,
  items,
  enabled,
}: {
  basketId?: IBasket["id"];
  items?: IOrderPreviewBody["items"];
  enabled?: boolean;
}) => {
  const [apiError, setApiError] = useState<IErrorResponse>();
  const [isAlreadyPaid, setAlreadyPaid] = useState(false);
  const [isAlreadyProcessed, setAlreadyProcessed] = useState(false);

  const randomId = () => {
    return process.env.STORYBOOK === "true" ? "test" : uuidv4();
  };

  const id = useRef<string>(randomId()).current;

  const { data: orderPreview, isLoading } = useDataQuery(
    ["basketOrderPreview", items],
    async () => {
      try {
        const params = {};
        items && (params["items"] = items);
        return await previewBasketOrder(basketId || id, params);
      } catch (error) {
        if (error?.response?.data?.error === "already_paid")
          setAlreadyPaid(true);
        else if (error?.response?.data?.error === "already_processed")
          setAlreadyProcessed(true);
        else setApiError(error);
      }
    },
    {
      enabled,
    }
  );

  return {
    orderPreview,
    isLoading,
    apiError,
    isAlreadyPaid,
    isAlreadyProcessed,
  };
};
